import { parse } from 'date-fns';
import { setTime } from './setTime';

export const setTimeFromString = (date: Date, time: string): Date => {
    const timeDate = parse(time, time.length === 4 ? 'HHmm' : 'HH:mm', date);
    return setTime(date, timeDate);
};
